const defaults = require('./defaults');

const { port, auth } = defaults;

module.exports = {
  ...defaults,
  favicon: true,
  token: {
    ...defaults.token,
    cookie: {
      domain: 'localhost',
    },
  },
  lsOnlineUrlRoot: 'https://development.ls-www.localsearch.cloud',
  imageResizeRoot: 'https://d1zmvcyjeoeklt.cloudfront.net',
  auth: {
    ...auth,
    domain: 'staging.auth.localsearch.cloud',
    audience: 'https://services.lsapis.com.au',
    clientID: 'z9CZdKCEDAAKEHnz5i4AgY2w1mSuEwHp',
    redirectUri: `http://localhost:${port}`,
  },
  api: 'https://development.services.lsapis.com.au',
  // api: 'http://localhost:3000',
};
